import axios from 'axios';

const getEntidade = () => axios.get('/entidades');

const updateLogoEntidade = entidade => axios.put(`/entidades/${entidade.id}/logo`, entidade);

export default {
  getEntidade,
  updateLogoEntidade,
};
